import { GET } from '@/app/api/index';
import STORE from '@/app/store/store';
import api from '@/app/endpoints.js';
import { Atom } from '@/app/editor/iframe/atom/Atom';
import type { AtomModel, Font } from '@/app/editor/iframe/atom/Atom.model';
import HELPER from '@/app/utils/HELPER';
import loadLoopItems from '@/app/utils/loadLoopItems';
declare let Liquid: any;

type RelatedProductsShopify = {
  collection: CollectionShopify;
};

type CollectionShopify = {
  product: ProductShopify;
};

type ProductShopify = {
  collections: any[];
  id: number;
  handle: string;
};

/**
 * Related Product Module
 */
export class GpRelatedProducts extends Atom {
  public $el: JQuery;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: 'Relared Products',
      slug: 'relared-products',
      groupName: 'Module',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: '.module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }

  /**
   * override renderLiquid từ Atom
   * @param templateTmp template string
   * @returns html string
   */
  async renderLiquid(templateTmp: string): Promise<string> {
    const template = HELPER.simpleHTMLEntities(templateTmp);
    const jsonData = await this.getRelatedProductsData();
    let html = '';

    if (jsonData && jsonData.collection.product.collections.length == 0) {
      this.$el.find('.module').html('<span style="display: block;text-align:center;">Products not found.</span>');
      HELPER.showNotify('Products not found.', 'error');
    } else {
      // Render liquid
      const tmpl = Liquid.parse(template);
      html = tmpl.render({
        product: jsonData['collection']['product'],
      });
    }

    return html;
  }

  /**
   * runtemplate
   * @returns boolean
   */
  async renderTemplate(): Promise<void> {
    let templateTmp = this.data.atom.html;
    templateTmp = this.renderSettings(templateTmp); // Render khung cho module và data cho module sử dụng
    this.$el.html(templateTmp); // Cần render settings trước để có khung và các value mặc định(pid)
    const moduleId = this.getModuleId();
    const $bkActiveModule = this.$divContentBk.find('#module-' + moduleId);
    let fields: any = [];
    this.getRelatedProductsData().catch(() => {
      const $settings = $bkActiveModule.find('.settings');
      try {
        let settingData = $settings.html();
        if (!settingData || !settingData.length) {
          settingData = '[]';
        }

        fields = jQuery.parseJSON(settingData);
      } catch (err) {
        const moduleName = this.getModuleName();
        // eslint-disable-next-line no-console
        console.log(moduleName + ' - ' + err.message);
        HELPER.showNotify(err.name + ': Error in Snippet Settings JSON', 'error');
      }
      for (let i = 0; i < fields.length; i++) {
        if (fields[i].name == 'product') {
          fields[i]['default_value'] = 'Auto';
        }
        if (fields[i].name == 'pid') {
          fields[i]['default_value'] = 'auto';
        }
        if (fields[i].name == 'pHandle') {
          fields[i]['default_value'] = 'auto';
        }
      }

      return this.getRelatedProductsData();
    });

    templateTmp = HELPER.replaceFields(fields, templateTmp);
    templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

    const moduleIdSlug = moduleId.toString().replace(/-/g, '');
    templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
    let html = '';

    html = await this.renderLiquid(templateTmp); // render child and render liquid
    html = this.renderSettings(html); // Render render setting id module cho các html childs
    this.$el.html(html);
  }

  /**
   * Call ajax to get product form backend
   * @returns data Promise with type ProductShopify
   */
  async getRelatedProductsData(): Promise<RelatedProductsShopify> {
    return new Promise(async (resolve, reject) => {
      let productId = this.$el.children('.module').attr('data-pid');
      if (productId == 'auto') {
        this.$gfFrame
          .contents()
          .find('body')
          .first()
          .find('[data-label="Product"]')
          .each(function () {
            if (jQuery(this).attr('data-status') == 'default' || jQuery(this).attr('data-status') == 'dynamic') {
              productId = jQuery(this).children('.module').attr('data-pid');
            }
          });
      }
      if (productId == undefined) {
        productId = 'auto';
      }
      const limit = parseInt(this.$el.find('.module').attr('data-limit') || '0');
      let excludes = '';
      if (this.$el.find('.module').attr('data-excludes') != undefined) {
        excludes = this.$el.find('.module').attr('data-excludes') || '0';
      }
      const relatedListData: any = HELPER.searchRelatedListInList(productId, limit, excludes);

      let isLoading = false;
      if (!jQuery.isEmptyObject(relatedListData)) {
        if (limit <= relatedListData['limit']) {
          (window as any)._isFirstLoadRelated = false;
        } else {
          isLoading = true;
        }
      } else {
        isLoading = true;
      }

      if (isLoading) {
        const shop = STORE.getValue('__shop').shopifyDomain;
        const data = {
          shop: shop,
          productId: productId,
          limit: limit,
          excludes: excludes,
        };
        this.showLoading();
        try {
          const res = await GET(api.getRelatedProducts().url, data);
          const jsonData = res.data;

          this.hideLoading();
          if (jsonData.collection) {
            for (let i = 0; i < jsonData.collection.product.collections.length; i++) {
              const collection = jsonData.collection.product.collections[i];

              const productId = jsonData.collection.product.id;
              const productHandle = jsonData.collection.product.handle;
              // set collection id
              this.$el
                .children('.module')
                .attr('data-cid', collection.id)
                .attr('data-pId', productId)
                .attr('data-pHandle', productHandle);

              const products = [];
              for (let k = 0; k < collection.products.length; k++) {
                const id = collection.products[k].id;
                if (id != productId) {
                  products.push(collection.products[k]);
                }
              }
              collection.products = products;

              for (let k = 0; k < collection.products.length; k++) {
                const productData = collection.products[k];

                const data = HELPER.searchProductInList(productData.id);
                if (jQuery.isEmptyObject(data)) {
                  HELPER.updateProductInList(productData);
                }
              }

              const relatedListObject = {
                pid: productId,
                limit: limit,
                excludes: excludes,
                list: jsonData,
              };

              HELPER.updateRelatedListInList(relatedListObject);
            }
            resolve(jsonData);
          }
          (window as any)._isFirstLoadRelated = false;
        } catch (err) {
          this.$gfFrame.data('gfframe').hideLoading();
          this.hideLoading();

          if (productId != 'auto') {
            this.$el.children('.module').attr('data-pid', 'auto').attr('data-phandle', 'auto');
            const moduleId = this.getModuleId();
            const $bkActiveModule = this.$divContentBk.find('#module-' + moduleId);
            const $settings = $bkActiveModule.find('.settings');
            let fields = [];
            try {
              fields = jQuery.parseJSON($settings.html());
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log(err.message);
            }
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'product') {
                fields[i]['default_value'] = 'Auto';
              }
              if (fields[i].name == 'pid') {
                fields[i]['default_value'] = 'auto';
              }
              if (fields[i].name == 'pHandle') {
                fields[i]['default_value'] = 'auto';
              }
            }

            $settings.html(JSON.stringify(fields));
            return this.getRelatedProductsData();
          } else {
            HELPER.showNotify('There are some errors occurred please try again. Error: 108', 'error');
          }
        }
      }

      return false;
    });
  }

  /**
   * [Init]
   * render
   * Thay thế cho hàm refresh cũ - với mục tiêu refresh lại module khi setting thay đổi
   */
  async render(): Promise<void> {
    this.applyEvents(); // alo
    this.renderStyle();
    await this.renderTemplate();
    this.initChilds();
    this.renderScript();
    this.renderChilds();
    /**
     * Khởi tạo các thành phần phụ trợ cho atom
     * ví dụ: dragable, outline, toolbar....
     */
    // utils.Init(this.$el, this.data);
    // Tạo placeholder cho việc kéo thả
    HELPER.generatePlaceholderForm(this.$el);
  }

  /**
   * renderChilds inside Product wrapper
   */
  renderChilds(): void {
    const pageType = this.$gfFrame.data('gfframe').getPageType();
    const moduleId = this.getModuleId();
    const $bkActiveModule = this.$divContentBk.find('#module-' + moduleId);
    const $templateChildHtml = $bkActiveModule.find('.template-child-html');
    const $templateChildBkHtml = $bkActiveModule.find('.template-child-bkhtml');

    let bkHtml = '',
      html = '';
    if ($templateChildHtml && $templateChildBkHtml && $templateChildHtml.html() && $templateChildBkHtml.html()) {
      let html = $templateChildHtml.html();
      html = html.replace(/scri-pt/g, 'script');
      html = HELPER.simpleHTMLEntities(html);

      bkHtml = $templateChildBkHtml.html();
      bkHtml = bkHtml.replace(/scri-pt/g, 'script');
      bkHtml = HELPER.simpleHTMLEntities(bkHtml);

      // Replace template-child-bkhtml
      bkHtml = bkHtml
        .replace(
          '<div class="gf_template-child-bkhtml-product-data"></div>',
          '<script class="data" type="application/json">{"items": [{"content":"<div class=\\"module-wrap\\" id=\\"m-1538714838899-0\\" data-id=\\"1538714838899-0\\" data-label=\\"(P) Image\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-1\\" data-id=\\"1538714838899-1\\" data-label=\\"(P) Title\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-2\\" data-id=\\"1538714838899-2\\" data-label=\\"(P) Price\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-3\\" data-id=\\"1538714838899-3\\" data-label=\\"(P) Cart Button\\"></div>","id":"i-15387148388990"}]}</script>',
        )
        .replace(
          '<div class="gf_template-child-bkhtml-article-data"></div>',
          '<script class="data" type="application/json">{"items": [{"content": "<div class=\\"module-wrap\\" id=\\"m-1523941222422-0\\" data-id=\\"1523941222422-0\\" data-label=\\"(A) Image\\"></div><div class=\\"module-wrap\\" id=\\"m-1523941222422-1\\" data-id=\\"1523941222422-1\\" data-label=\\"(A) Title\\"></div><div class=\\"module-wrap\\" id=\\"m-1523941222422-2\\" data-id=\\"1523941222422-2\\" data-label=\\"(A) Content\\"></div>","id": "i-15239412224220"}]}</script>',
        );

      // Update Preview URL
      if (pageType == 'template-collection') {
        const collectionHandle = this.$el.children('.module').attr('data-chandle');

        let preViewPageLink = this.$gryffEditor.data('gryffeditor').getPreviewPageLink();
        preViewPageLink = preViewPageLink.replace(/&collection(.*)/, '&collection=' + collectionHandle);

        let viewPageLink = this.$gryffEditor.data('gryffeditor').getViewPageLink();
        viewPageLink = viewPageLink.replace(/\/collections\/(.*)/, '/collections/' + collectionHandle);

        this.$gryffEditor.data('gryffeditor').setPreviewPageLink(preViewPageLink);
        this.$gryffEditor.data('gryffeditor').setViewPageLink(viewPageLink);
      }
    } else {
      html =
        '<div data-label="Product" data-key="product" id="m-{{snippet-id}}" class="module-wrap" data-id="{{snippet-id}}"></div>';

      const childrenLayout = [
        {
          label: 'Product',
          key: 'product',
          id: '{{snippet-id}}',
        },
        {
          label: '(P) Image',
          key: 'p-image',
          id: '{{snippet-id}}-0',
        },
        {
          label: '(P) Title',
          key: 'p-title',
          id: '{{snippet-id}}-1',
        },
        {
          label: '(P) Price',
          key: 'p-price',
          id: '{{snippet-id}}-2',
        },
        {
          label: '(P) Cart Button',
          key: 'p-cart-button',
          id: '{{snippet-id}}-3',
        },
      ];

      const childLayoutLength = childrenLayout.length;
      for (let i = 0; i < childLayoutLength; i++) {
        const storeSnippet = this.getDataSnippetByKey(childrenLayout[i].key);
        const $snippet = jQuery(storeSnippet);
        bkHtml += `<div id="module-${childrenLayout[i].id}">`;
        bkHtml += $snippet.html().replace(/{{module-id}}/gim, childrenLayout[i].id);
        bkHtml += '</div>';
      }
    }

    loadLoopItems(this.$el, this.$gryffEditor, this.getModuleId(), this.getModuleName(), html, bkHtml);
  }

  /**
   * GetModuleId
   * @returns number
   */
  getModuleId() {
    let moduleId = HELPER.MakeIdInsideList(this.$el);
    if (moduleId == '') {
      moduleId = this.$el.attr('data-id') || HELPER.MakeId().toString();
    }

    return moduleId;
  }

  /**
   * Show Loading
   * @returns boolean
   */
  showLoading() {
    this.$el.gfLoader();
    this.$el.data('gfloader').show();
    return false;
  }
  /**
   * Hide Loading
   * @returns boolean
   */
  hideLoading() {
    this.$el.data('gfloader').hide();
    if (this.$el.find('.gf_loader').length > 0) {
      this.$el.find('.gf_loader').remove();
    }
    return false;
  }

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Related Product';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'related-product';
  }
  /**
   * get Data from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }
}
